/**
 * Newsletter Service
 *
 * API calls for The Daily Edge newsletter functionality.
 */

import api from './api';

const newsletterService = {
  /**
   * Get today's newsletter
   */
  getToday: async () => {
    const response = await api.get('/newsletters/today');
    return response.data;
  },

  /**
   * Get newsletter by date
   * @param {string} date - Date in YYYY-MM-DD format
   */
  getByDate: async (date) => {
    const response = await api.get(`/newsletters/${date}`);
    return response.data;
  },

  /**
   * Get newsletter archive
   * @param {number} limit - Number of newsletters to fetch
   * @param {number} offset - Offset for pagination
   */
  getArchive: async (limit = 10, offset = 0) => {
    const response = await api.get('/newsletters/archive', {
      params: { limit, offset }
    });
    return response.data;
  },

  /**
   * Subscribe to newsletter
   * @param {string} email - Email address
   * @param {string} name - Optional name
   * @param {string} sportsPreference - Comma-separated sports (e.g., "nba,nhl")
   */
  subscribe: async (email, name = null, sportsPreference = null) => {
    const response = await api.post('/newsletters/subscribe', {
      email,
      name,
      sports_preference: sportsPreference
    });
    return response.data;
  },

  /**
   * Unsubscribe from newsletter
   * @param {string} token - Unsubscribe token
   */
  unsubscribe: async (token) => {
    const response = await api.post('/newsletters/unsubscribe', { token });
    return response.data;
  },

  /**
   * Get newsletter stats (admin)
   */
  getStats: async () => {
    const response = await api.get('/newsletters/stats');
    return response.data;
  },

  /**
   * Trigger newsletter generation (admin)
   * @param {string} date - Optional date in YYYY-MM-DD format
   * @param {string[]} sports - Optional list of sports
   */
  generate: async (date = null, sports = null) => {
    const response = await api.post('/newsletters/generate', {
      newsletter_date: date,
      sports
    });
    return response.data;
  },

  /**
   * Send newsletter to subscribers (admin)
   * @param {number} newsletterId - Newsletter ID to send
   * @param {string} testEmail - Optional test email
   */
  send: async (newsletterId, testEmail = null) => {
    const response = await api.post(`/newsletters/send/${newsletterId}`, {
      test_email: testEmail
    });
    return response.data;
  }
};

export default newsletterService;
